export default "__VITE_ASSET__CxkNnfjk__"